<template>

	<div>
		<div id="posProducts">
			<b-table
				small hover bordered striped
				:fields="fields"
				:items="getCartItems"
				class="generalTableClass posProductsTable"
			>
				<template slot="index" slot-scope="data">
					{{ data.index + 1 }}
				</template>

				<template slot="Продукт" slot-scope="data">
					{{data.item.name ? data.item.name : '' }} / <strong>{{ data.item.artikul
					}}</strong> / {{ data.item.colorName }} / <strong>{{ data.item.size }}</strong>
				</template>

				<template slot="quantity" slot-scope="data">
					<b-input-group size="sm" class="posQtyButton">
						<b-input-group-prepend>
							<b-button variant="secondary" size="sm"
									  @click="decreaseQty(data.index)"
									  :disabled="isCountBtnsDisabled"
							>
								-
							</b-button>
						</b-input-group-prepend>

						<b-form-input
							type="number"
							min="1"
							autocomplete="off"
							:value="getCountOfItem(data.index)"
							@blur="savePos('draft')"
							@input="setCount($event, data.index)"
							@keyup.enter.native="$emit('focusSearchBar')"
							@focus="$event.target.select()"
						></b-form-input>

						<b-input-group-append>
							<b-button variant="success" size="sm"
									  @click="increaseQty(data.index)"
									  :disabled="isCountBtnsDisabled"
							>
								+
							</b-button>
						</b-input-group-append>
					</b-input-group>
					<!-- OMBORDAGI QOLDIQDAN KO'P KIRITVORSA CHIQADI BU YOZUV -->
					<p
						v-if="getCountOfItem(data.index) > data.item.qty"
						style="color: red;"
					>
						Доступно только {{ data.item.qty }} {{ data.item.unitName ?
						data.item.unitName : 'шт.'}}
					</p>
				</template>

				<template slot="price" slot-scope="data">
					{{ data.item.priceUzs | currency({symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back'}) }}
				</template>

				<template slot="pul" slot-scope="data">
					{{ afterPromotionSum(data.item) | currency({
					symbol:
					userDepCurrencyName, fractionCount: 2, symbolPosition: 'back'
					}) }}
				</template>
				<template slot="percentage" slot-scope="data">
					{{ afterPromotionPercentage(data.item) | currency({
					symbol:
					'%', symbolPosition: 'back'
					}) }}
				</template>
				<template slot="discountPriceUzs" slot-scope="data">
					{{data.item.discountPriceUzs | currency({
					symbol: userDepCurrencyName, fractionCount: 2, symbolPosition:
					'back'
					}) }}
				</template>

				<template slot="subtotal" slot-scope="data">
					{{ data.item.discountPriceUzs * data.item.count | currency({
					symbol:
					userDepCurrencyName, fractionCount: 2,
					symbolPosition: 'back'
					})}}
				</template>

				<template slot="inventoryQty" slot-scope="data">
					{{ data.item.qty }} {{ data.item.unitName ? data.item.unitName : 'шт.'}}
				</template>

				<template slot="actions" slot-scope="data">
					<b-link :key="data.item.id + 'delete'"
							@click="deleteFromCart(data.index)"
					>
						<i class="fa fa-trash"></i>
					</b-link>
					<b-link :key="data.item.id + 'update'"
							@click="openItemForDiscount(data, data.index)"
					>
						<i class="fa fa-pencil-square-o cursor-pointer"></i>
					</b-link>
				</template>
			</b-table>
		</div>
		<b-modal hide-footer v-model="discountOpenModal"
				 @shown="focusMyDiscount"
				 :title='discountTForTitle? `Скидка на ${saleItemForDiscountModal.item.name}`: "Скидка на чек"'>
			<item-discount-for-wholesale @emitClose="closeEmit"
						  @saveSuccess="savePos('draft')"
						  :itemIndex="currentItemIndex"
						  ref="posDiscount"
			></item-discount-for-wholesale>
		</b-modal>
		<!--<div class="generalTableClass table-responsive-true">
			<b-table
				:items="dataSource"
				:fields="columns"
				hover="hover"
				striped="striped"
				bordered="bordered"
			>
				&lt;!&ndash; EMPTY SLOT FOR TABLE &ndash;&gt;
				<template slot="empty" slot-scope="scope">
					<h4>{{ $t('empty') }}</h4>
				</template>
				<template slot="id" slot-scope="data">
					{{ data.index + 1 }}
				</template>

				&lt;!&ndash; EMPTY SLOT FOR TABLE &ndash;&gt;
				<template slot="artikul" slot-scope="data">
					{{ data.item.artikul }}
				</template>
				<template slot="color" slot-scope="data">
					{{ data.item.color }}
				</template>
				<template slot="size" slot-scope="data">
					{{ data.item.size }}
				</template>
				<template slot="realBalance" slot-scope="data">
					{{ data.item.realBalance>0?data.item.realBalance:0 }}
				</template>
				<template slot="itemName" slot-scope="data">
					<span v-if="data.item.wrapped"><strong>Мешок - </strong>{{ data.value ? data.value.substring(0, 30) : '-' }}</span>
					<span v-else>{{ data.value ? data.value.substring(0, 30) : '-' }}</span>
				</template>
				<template slot="count" slot-scope="data">
					<b-form-input :ref="data.index + '1'" type="text"
								  v-if="ok && (section == 'KIRIM' ||section=='KOCHIRISH')"
								  onClick="this.setSelectionRange(0, this.value.length)"
								  @keyup.up.left.right.down="focusInput($event ,data.index, 1)"
								  v-model.number="data.item.count" class="move" @input="checkCount(data.index,$event)">
					</b-form-input>
					<div v-else-if="section == 'KIRIM' ||section=='KOCHIRISH'" data-toggle="tooltip"
						 :title="$t('pricing.update')"
						 @click="OkFunction(data.index + '1')">
						{{data.value}} {{data.item.unitName}}
					</div>
					<div v-else>

						{{data.value}} {{data.item.unitName}}
					</div>
				</template>
				<template slot="incomeUzs" slot-scope="data">
					<b-form-input :ref="data.index + '2'" type="text" v-if="ok && section == 'KIRIM'"
								  onClick="this.setSelectionRange(0, this.value.length)"
								  @keyup.up.left.right.down="focusInput($event ,data.index, 2)"
								  v-model="data.item.incomingPriceUzs" class="move">
					</b-form-input>
					<div v-else-if="section == 'KIRIM'" data-toggle="tooltip" :title="$t('pricing.update')"
						 @click="OkFunction(data.index + '2')">
						<div class="inputWidth"> {{data.item.incomingPriceUzs ? data.item.incomingPriceUzs : 0 |
							currency({
							symbol: computedDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ' '
							})}}
						</div>
					</div>
					<div v-else class="inputWidth"> {{data.item.incomingPriceUzs ? data.item.incomingPriceUzs : 0 |
						currency({
						symbol: 'c', symbolPosition: 'back',
						thousandsSeparator: ' '
						})}}
					</div>
				</template>
				<template slot="newUzb" slot-scope="data">
					<b-form-input :ref="data.index + '3'" type="text" v-if="ok && section == 'KIRIM'"
								  onClick="this.setSelectionRange(0, this.value.length)"
								  @keyup.up.left.right.down="focusInput($event ,data.index, 3)"
								  v-model="data.item.priceUzs" class="move">
					</b-form-input>
					<div v-else-if="section == 'KIRIM'" data-toggle="tooltip" :title="$t('pricing.update')"
						 @click="OkFunction(data.index + '3')">
						<div class="inputWidth"> {{data.item.priceUzs ? data.item.priceUzs : 0 | currency({
							symbol: computedDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ' '
							})}}
						</div>
					</div>
					<div class="inputWidth" v-else> {{data.item.priceUzs ? data.item.priceUzs : 0 | currency({
						symbol: computedDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
						thousandsSeparator: ' '
						})}}
					</div>
				</template>
				<template slot="incomeUsd" slot-scope="data">
					<b-form-input :ref="data.index + '3'" type="text" v-if="ok"
								  @keyup.up.left.right.down="focusInput($event ,data.index, 3)"
								  onClick="this.setSelectionRange(0, this.value.length)"
								  v-model="data.item.incomingPriceUsd" class="move">
					</b-form-input>
					<div v-else data-toggle="tooltip" :title="$t('pricing.update')"
						 @click="OkFunction(data.index + '3')">
						<div class="inputWidth"> {{data.item.incomingPriceUsd ? data.item.incomingPriceUsd : 0}}</div>
					</div>
				</template>
				<template slot="newUsd" slot-scope="data">
					<b-form-input :ref="data.index + '4'" type="text" v-if="ok"
								  @keyup.up.left.right.down="focusInput($event ,data.index, 4)"
								  onClick="this.setSelectionRange(0, this.value.length)"
								  v-model="data.item.priceUsd" class="move">
					</b-form-input>
					<div v-else data-toggle="tooltip" :title="$t('pricing.update')"
						 @click="OkFunction(data.index + '4')">
						<div class="inputWidth"> {{data.item.priceUsd ? data.item.priceUsd : 0 | currency({
							symbol: computedDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ' '
							})}}
						</div>
					</div>
				</template>
				<template slot="priceUsd" slot-scope="data">
					{{ data.value * data.item.count }}$ (USD)
				</template>
				<template slot="priceUzs" slot-scope="data">
					{{ data.value * data.item.count | currency({
					symbol: computedDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
					thousandsSeparator: ' '
					}) }}
				</template>
				<template slot="itemIncomeTotal" slot-scope="data">
					{{ data.item.incomingPriceUzs * data.item.count | currency({
					symbol: computedDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
					thousandsSeparator: ' '
					}) }}
				</template>
				<template slot="actions" slot-scope="data">
					<b-link
						:key="data.index + 'delete'"
						:id="'popOverDelete'+data.index"
						@click="showConfirm(data.index)"
					>
						<i class="fa fa-trash"></i>
					</b-link>
					<b-popover
						:key="data.index + 'popover'"
						:target="'popOverDelete'+data.index"
						placement="bottom"
						:ref="'popover'+data.index"
						class="refDeleteConfirm inSidebar"
					>
						<template slot="title">
							<b-button @click="closeConfirm(data.index)" class="close" aria-label="Close"
									  style="margin-left: 5px">
								<span class="d-inline-block" aria-hidden="true">&times;</span>
							</b-button>
							{{ $t('want_to_delete?') }}
						</template>

						<div>
							<div class="row mt-1">
								<div class="col-6">
									<b-button variant="outline-danger" size="sm" block
											  @click="closeConfirm(data.index)"> {{ $t('actions.no') }}
									</b-button>
								</div>
								<div class="col-6">
									<b-button variant="outline-success" size="sm" block @click="remove(data.index)">{{
										$t('actions.yes') }}
									</b-button>
								</div>
							</div>
						</div>
					</b-popover>
				</template>
			</b-table>
		</div>-->
	</div>


</template>

<script>
	import { mapActions, mapState, mapGetters } from 'vuex';
    import ItemDiscountForWholesale from "./ItemDiscountForWholesale";
    import {TokenService} from "../../../../services/storage.service";

    export default {
		name: 'ItemList',

		props: {
			items: {
				type: Array,
				default: null
			},
			section: {
				type: String,
				default: 'KIRIM'
			},
			mode: {
				type: String,
				default: 'create',
			},
            depCurrencyName: {
                type: String,
                default: ''
            }
		},
		components: {
            ItemDiscountForWholesale
		},
		data() {
			return {
                tempForSale: {
                    'action': 'OPTOM_SAVDO',
                },
                isCountBtnsDisabled: false,
                dateTime: '',
                discountTForTitle: false,
                discountOpenModal: false,
                discountOptomOpenModal: false,
                currentItemIndex: null,
                fields: [
                    'Продукт',

                    {
                        key: 'quantity',
                        label: 'Количество',
                        'class': 'noDefaultButton, width15_wordBreak',
                    },
                    {
                        key: 'price',
                        label: 'Цена'
                    },
                    {
                        key: 'pul',
                        label: 'Скидка'
                    },
                    {
                        key: 'percentage',
                        label: 'Скидка %'
                    },
                    {
                        key: 'discountPriceUzs',
                        label: 'Цена со скидкой'
                    },

                    {
                        key: 'subtotal',
                        label: 'Сумма'
                    },

                    {
                        key: 'inventoryQty',
                        label: 'Остатка',
                        'class': 'textAlignCenter'
                    },
                    // {
                    // 	key: 'delete',
                    // 	label: this.$t('goods.actions'),
                    // 	'class': 'table_actions'
                    // },
                    // {
                    // 	key: 'update',
                    // 	label: this.$t('goods.actions'),
                    // 	'class': 'table_actions'
                    // },
                    {
                        key: 'actions',
                        label: 'Действие',
                        'class': 'table_actions'
                    }
                ],

                customCount: 1,
                /*fields: [
					{
						key: 'id',
						label: '№',
						sortable: true
					},
					{
						key: 'artikul',
						label: "Артикул",
						'class': 'incomeItemArtikul',
						sortable: true,
						visible: true,
						changebale: true
					},
					{
						key: 'color',
						label: "Цвет",
						'class': 'incomeItemArtikul',
						sortable: true,
						visible: true,
						changebale: true
					},
					{
						key: 'size',
						label: "Размер",
						'class': 'incomeItemSize',
						sortable: true,
						visible: true,
						changebale: true
					},
					{
						key: 'itemName',
						label: this.$t('incomes.create.product'),
						'class': 'not-first',
						sortable: true,
						visible: true,
						changebale: true
					},
					{
						key: 'count',
						label: this.$t('incomes.create.count'),
						'class': 'td-30',
						sortable: true,
						visible: true,
						changebale: true
					},
					{
						key: 'realBalance',
						label: "Остатка",
						'class': 'td-30',
						sortable: true,
						visible: true,
						changebale: true
					},
					{
						key: 'incomeUzs',
						label: 'Цена (приход)',
					},
					{
						key: 'newUzb',
						label: this.section == 'KIRIM' ? 'Цена (новая)' : 'Цена (штук)',

					},
					/!*{
						key: 'incomeUsd',
						label: this.$t('money.incomeUsd'),

					},
					{
						key: 'newUsd',
						label: this.$t('money.newUsd'),

					},*!/
					/!*{
						key: 'priceUsd',
						label: `${this.$t('incomes.create.price')} (USD)`,
						'class': 'td-30',
						sortable: true,
						visible: true,
						changebale: true
					},*!/
					{
						key: 'itemIncomeTotal',
						label: 'Сумма (приход)',
						'class': 'td-30',
						sortable: true,
						visible: true,
						changebale: true
					},
					{
						key: 'priceUzs',
						label: 'Сумма (Цена)',
						'class': 'td-30',
						sortable: true,
						visible: true,
						changebale: true
					},
					{
						label: `${this.$t('incomes.actions')}`,
						key: 'actions',
						'class': 'table_actions',
						visible: true,
						changebale: false
					}

				],*/
				ok: false,
			}
		},
		computed: {
            ...mapState('pos', [
                'totalCount', 'totalSum', 'checkPage', 'finalTotalSum', 'realTotalSum', 'comment',
                'shopName', 'currentSaleNumber',
                'currentSaleId',
                'shopAddress', 'cashierFullName', 'currentSellerName','sellerId',
                'currentSuspendId', 'currentSaleSuspendNumber', 'lastSuspendedSaleNumber', 'saleItemForDiscountModal', 'discount', 'customPromotion', 'errorOccur',
                'searchLoading', 'saleFinishError', 'saleFinishLoading',
                'isReturn'
            ]),
            ...mapGetters('pos', [
                'getItems', 'getCartItems', 'getDiscountItemForModal'
            ]),
            ...mapState(['userDepCurrencyName']),
            computedDepCurrencyName() {
                return this.depCurrencyName || this.userDepCurrencyName;
            },
			dataSource() {
				return this.items;
			},
			columns() {
				if (this.section !== 'KIRIM') {
					// this.fields.splice(6, 1);
					this.fields.splice(7, 1);
					this.fields.splice(8, 1);
				} else {
					this.fields.splice(6, 1);
				}
				return this.fields;
			}
		},
		methods: {
            closeEmit(event) {
                this.discountOpenModal = event;
            },
            focusMyDiscount() {
                this.$refs.posDiscount.$refs.fixedRef.focus();
                this.$refs.posDiscount.$refs.percentageRef.focus();
            },
            makeCurrentDateTime(forMethod) {
                let now = new Date();
                let year = now.getFullYear();
                let month = now.getMonth() + 1;
                let day = now.getDate();
                let hour = now.getHours();
                let minute = now.getMinutes();
                let second = now.getSeconds();
                if (month.toString().length == 1) {
                    month = '0' + month;
                }
                if (day.toString().length == 1) {
                    day = '0' + day;
                }
                if (hour.toString().length == 1) {
                    hour = '0' + hour;
                }
                if (minute.toString().length == 1) {
                    minute = '0' + minute;
                }
                if (second.toString().length == 1) {
                    second = '0' + second;
                }
                if (forMethod == 'savePos') {
                    return month + '-' + day + '-' + year;
                }
                this.dateTime = year + '/' + month + '/' + day + ' ' + hour + ':' + minute + ':' + second;
            },
            ...mapActions('pos', [
                'getItemsForPos', 'increaseCount', 'setIncrementValue',
                'decreaseCount', 'deleteFromCartAction', 'saleFinish', 'createPosDraft',
                'editDraft', 'getLatestSuspends', 'suspendSale', 'setSaleItemForDiscountModal', 'setSusPendClient', 'setErrorOccurNotHappen', 'editDraftOptom',
				'editWholesale'
            ]),
            openItemForDiscount(data, index) {
                if (data.item.customPromotion.discount) {
                    if (data.item.customPromotion.promotionType == '%') {

                        this.$refs.posDiscount.itemLocal.percentage = data.item.customPromotion.discount;
                        this.$refs.posDiscount.itemLocal.fixed = '';
                    } else {

                        this.$refs.posDiscount.itemLocal.fixed = data.item.customPromotion.discount;
                        this.$refs.posDiscount.itemLocal.percentage = '';
                    }
                } else {
                    this.$refs.posDiscount.itemLocal.fixed = '';
                    this.$refs.posDiscount.itemLocal.percentage = '';
                }
                this.currentItemIndex = index;
                this.setSaleItemForDiscountModal(data);
                this.discountTForTitle = true;
                this.discountOpenModal = true;
            },
            async deleteFromCart(index) {
                await this.deleteFromCartAction(index);
                await this.savePos('draft');
               	await this.$root.$emit('focusSearchBarWholesale')
            },
            afterPromotionPercentage(item) {
                let promoparam1;
                if (item.promotions) {
                    for (let i = 0; i < item.promotions.length; i++) {
                        if (item.promotions[i].type == "%") {
                            promoparam1 = item.promotions[i].value
                        }
                    }
                    return promoparam1;

                }
            },
            afterPromotionSum(item) {
                let promoparam;
                if (item.promotions) {
                    for (let i = 0; i < item.promotions.length; i++) {
                        if (item.promotions[i].type == "PUL") {
                            promoparam = item.promotions[i].value
                        }
                    }
                    return promoparam;
                }

            },
            async setCount(event, index) {
                let inputCount = parseFloat(event)
                if (!inputCount) {
                    let payload = {};
                    payload.index = index;
                    payload.newCount = 1;
                    await this.setIncrementValue(payload);
                } else {
                    if (inputCount > 0) {
                        let payload = {};
                        payload.index = index;
                        payload.newCount = inputCount;
                        await this.setIncrementValue(payload);
                    } else {
                        let payload = {};
                        payload.index = index;
                        payload.newCount = 1;
                        await this.setIncrementValue(payload);
                    }
                }

            },
            async savePos(status) {
                this.discountOpenModal = false;
                /*if (this.getFromModalMemberCard) {
                    this.tempForSale.customerId = this.getFromModalMemberCard.id;
                } else if (this.getCurrentClient) {
                    this.tempForSale.customerId = this.getCurrentClient.id;
                } else if (this.getCurrentClientFromModal) {
                    this.tempForSale.customerId = this.getCurrentClientFromModal.id;
                } else {
                    this.tempForSale.customerId = null;
                }*/
                this.tempForSale.comment = this.localComment;
                this.tempForSale.saleDate = this.makeCurrentDateTime('savePos')

                this.tempForSale.cashboxNumber = localStorage.getItem('cash_number');
                this.tempForSale.amountOfPaymentUzs = this.realTotalSum;
                this.tempForSale.amountOfAfterPromoUzs = this.finalTotalSum;
                this.tempForSale.customPromotion = this.customPromotion;
                this.tempForSale.cashierFullName = this.cashierFullName;
                this.tempForSale.sellerId = this.sellerId;
                this.tempForSale.saleItems = this.getCartItems;
                if (this.multiPays) {
                    this.tempForSale.payments = this.multiPays;
                }
                if (status == 'ready') {
                    if (this.getCartItems.length > 0) {
                        await this.saleFinish(this.tempForSale);
                        if (!this.saleFinishError) {
                            this.$vs.notify({
                                time: 1000,
                                title: 'Продажа выполнена успешно!',
                                color: 'success',
                                icon: 'close',
                                position: 'top-right'
                            });
                            this.$store.commit('pos/setIsReturn', false);
                            await this.$root.$emit('focusSearchBarWholesale')
                        }
                    } else {
                        this.$vs.notify({
                            title: 'Пожалуйста, добавьте продукт',
                            color: 'warning',
                            icon: 'close',
                            position: 'top-right'
                        });
                    }
                    await this.clearSearchBar();
                    await this.$root.$emit('focusSearchBarWholesale')
                } else if (status == 'draft') {
                    await this.editWholesale(this.tempForSale);
                } else if (status == 'suspended') {
                    await this.suspendSale(this.tempForSale);
                }
            },
            getCountOfItem(index) {
                return this.getCartItems[index].count > 0 ? this.getCartItems[index].count : -this.getCartItems[index].count;
            },
            async decreaseQty(dataDecrease) {
                this.isCountBtnsDisabled = true;
                await this.decreaseCount(dataDecrease);
                await this.savePos('draft');
                this.isCountBtnsDisabled = false;
                await this.$root.$emit('focusSearchBarWholesale')
            },
            async increaseQty(dataindex) {
                this.isCountBtnsDisabled = true;
                await this.increaseCount(dataindex);
                await this.savePos('draft');
                this.isCountBtnsDisabled = false;
                await this.$root.$emit('focusSearchBarWholesale')
            },
			async checkCount(index, $event) {
				if (this.dataSource[index].realBalance < $event && this.section!=='KIRIM') {
					this.dataSource[index].count = await this.dataSource[index].realBalance;

					this.$vs.notify({
						title: "Количество",
						text: 'Проверьте количество товаров!',
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
				}
			},
			showConfirm(item) {
				let refName = 'popover' + item;
				this.$refs[refName].$emit('open')
			},
			closeConfirm(item) {
				let refName = 'popover' + item;
				this.$refs[refName].$emit('close')
			},
			remove(index) {
                let refName = 'popover' + index;
                this.$refs[refName].$emit('close')
                this.$emit('remove', index)
			},
			focusInput($event, index, inputOrder) {
				let lastIndex = this.dataSource.length - 1;
				if ($event.keyCode == 37) {
					if (inputOrder == 1 && index == 0) {
						return 1
					}
					if (inputOrder == 1 && index != 0) {
						const refName = (index - 1).toString() + '3'
						this.$refs[refName].$el.focus()
						this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
						return
					}
					if (inputOrder == 3) {
						const refName = index.toString() + (parseInt(inputOrder) - 1).toString()
						this.$refs[refName].$el.focus()
						this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
						return
					}
					const refName = index.toString() + (parseInt(inputOrder) - 1).toString()
					this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
					this.$refs[refName].$el.focus()
				}
				if ($event.keyCode == 39) {
					if (inputOrder == 3 && lastIndex == index) {
						return 1
					}
					if (inputOrder == 3 && lastIndex != index) {
						const refName = (index + 1).toString() + '1'
						this.$refs[refName].$el.focus()
						this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
						return
					}
					const refName = index.toString() + (parseInt(inputOrder) + 1).toString()
					this.$refs[refName].$el.focus()
					this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
				}
				if ($event.keyCode == 38) {
					if (index == 0) {
						return 1
					}
					const refName = (index - 1).toString() + (inputOrder).toString()
					this.$refs[refName].$el.focus()
					this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
				}
				if ($event.keyCode == 40) {
					if (index == lastIndex) {
						return 1
					}
					const refName = (index + 1).toString() + (inputOrder).toString()
					this.$refs[refName].$el.focus()
					this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
				}

			},
			async OkFunction(refName) {
				await this.changeOk();
				await this.focusRef(refName)
			},
			changeOk() {
				this.ok = true;
				return true
			},
			focusRef(refName) {
				this.$refs[refName].focus();
				this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
				return true;
			},
		},
		mounted() {
            this.$root.$on('savePosDraft', () => {
                this.savePos('draft');
            });
        },
		async created() {
            await this.createPosDraft(this.tempForSale);
        }
    }
</script>

<style scoped>
	th {
		padding: 2px;
	}
</style>
